/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_PlaceholderInputs */

const en_admin_ai_chat_placeholder = /** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the AI assistant…`)
};

const de_admin_ai_chat_placeholder = /** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frage den KI-Assistenten…`)
};

const es_admin_ai_chat_placeholder = /** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta al asistente de IA…`)
};

const fr_admin_ai_chat_placeholder = /** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demandez à l'assistant IA…`)
};

const nl_admin_ai_chat_placeholder = /** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vraag het de AI-assistent…`)
};

/** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */
const it_admin_ai_chat_placeholder = en_admin_ai_chat_placeholder;

/** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_placeholder = en_admin_ai_chat_placeholder;

/** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */
const pl_admin_ai_chat_placeholder = en_admin_ai_chat_placeholder;

/** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */
const hu_admin_ai_chat_placeholder = en_admin_ai_chat_placeholder;

/** @type {(inputs: Admin_Ai_Chat_PlaceholderInputs) => LocalizedString} */
const ro_admin_ai_chat_placeholder = en_admin_ai_chat_placeholder;

/**
* | output |
* | --- |
* | "Ask the AI assistant…" |
*
* @param {Admin_Ai_Chat_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_placeholder = /** @type {((inputs?: Admin_Ai_Chat_PlaceholderInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_PlaceholderInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_placeholder(inputs)
	if (locale === "de") return de_admin_ai_chat_placeholder(inputs)
	if (locale === "es") return es_admin_ai_chat_placeholder(inputs)
	if (locale === "fr") return fr_admin_ai_chat_placeholder(inputs)
	if (locale === "nl") return nl_admin_ai_chat_placeholder(inputs)
	if (locale === "it") return it_admin_ai_chat_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_placeholder(inputs)
	if (locale === "pl") return pl_admin_ai_chat_placeholder(inputs)
	if (locale === "hu") return hu_admin_ai_chat_placeholder(inputs)
	return ro_admin_ai_chat_placeholder(inputs)
});
export { admin_ai_chat_placeholder as "admin.ai_chat.placeholder" }